export default __webpack_public_path__ + "locales/az/Settings.json?hash=2d7662543d4afaa0e5e519e13951a396";